import { PersonNationalIdentifierFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

/** ИИН сотрудника — поле под защитой, поэтому показывается через `Value`. */
export function PersonNationalIdentifier({
  data,
}: {
  data?: Hidable<PersonNationalIdentifierFragment>;
}) {
  return (
    <Value data={data}>
      {(person) => <Value data={person.nationalIdentifier} />}
    </Value>
  );
}
